import api from "./core";

const basePath = "api/core/PortalAccess";

export default {
  query(patientId) {
    return api.post(`${basePath}/${patientId}`, {
      "Hide-Loading": true
    });
  },
  findAllAccess(patientId) {
    return api.post(`${basePath}/FindAllAccess/${patientId}`, {
      "Hide-Loading": true
    });
  },
  grantAccess(patientId, email) {
    return api.patch(`${basePath}/GrantAccess`, {
      patientId,
      email
    });
  },
  revokeAccess(patientId, email) {
    return api.patch(`${basePath}/RevokeAccess`, {
      patientId,
      email
    });
  },
  getAll() {
    return api.get(`${basePath}`, {
      "Hide-Loading": true
    });
  },
  queryById(id) {
    return api.get(`${basePath}/FindById/${id}`, {
      "Hide-Loading": true
    });
  }
};
